import i18n from "@/i18n";
import { useEffect } from "react";
import useGetUserProfile from "../useGetUserProfile";

const updateLanguageMetaTags = (language: string) => {
    document.documentElement.lang = language;

    const languageMeta = document.querySelector('meta[name="language"]');
    if (languageMeta) {
        languageMeta.setAttribute("content", language);
    }

    const contentLanguageMeta = document.querySelector(
        'meta[http-equiv="Content-Language"]',
    );
    if (contentLanguageMeta) {
        contentLanguageMeta.setAttribute("content", language);
    }
};

const useSyncLanguageSettings = () => {
    const { data: user } = useGetUserProfile();

    const syncLanguage = () => {
        const clientLanguage = i18n.language;

        if (!user) {
            updateLanguageMetaTags(clientLanguage);

            return;
        }

        const settingsLanguage = user.settings.preferredLanguage;

        if (settingsLanguage && clientLanguage !== settingsLanguage) {
            i18n.changeLanguage(settingsLanguage);
        }

        updateLanguageMetaTags(settingsLanguage ?? clientLanguage);
    };

    useEffect(() => {
        syncLanguage();
    }, [user]);
};

export default useSyncLanguageSettings;
